import React, { useState } from 'react';
import { CardsBlocks } from './components/CardsBlocks/CardsBlocks';
import { CardsTable } from './components/CardsTable/CardsTable';
import { useRecoilState } from 'recoil';
import { defaultIsMobile } from '../../../../../utils/states/isMobile.state';
import { FormProvider, type SubmitHandler, useForm } from 'react-hook-form';
import { type IInputsEditCard } from './components/components/ChangeDescriptionInput/ChangeDescriptionInput';
import { parseStringToNumber } from '../../../../../utils/functions/parseNumber';
import { useEditCardMutation } from '../../../../../redux/services/CardsApi';
import { pushNotify } from 'components/Notifications';

export interface TCardsContentProps {
  currentId: null | number;
  setCurrentId: React.Dispatch<React.SetStateAction<null | number>>;
  page: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  pageSize: number;
  search: string;
  currentPageIds: number[];
  setCurrentPageIds: React.Dispatch<React.SetStateAction<number[]>>;
}

export const CardsContent = () => {
  const [version] = useRecoilState(defaultIsMobile);
  const [currentId, setCurrentId] = useState<number | null>(null);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [search, setSearch] = useState('');
  const [currentPageIds, setCurrentPageIds] = useState<number[]>([]);
  const formMethods = useForm<IInputsEditCard>({
    defaultValues: {
      newDescription: '',
      newLimit: '0',
      newMinIncome: 0,
      newMaxIncome: 0,
      newInstantOrders: '0',
      newDailyLimit: '0',
      newMonthlyLimit: '0',
      newDailyLimitEnabled: false,
      newMonthlyLimitEnabled: false,
    },
  });
  const { handleSubmit, reset } = formMethods;
  const [updateCard] = useEditCardMutation();

  const handleEdit: SubmitHandler<IInputsEditCard> = async (data) => {
    const body = {
      total_limit: parseStringToNumber(data.newLimit),
      daily_total_limit: parseStringToNumber(data.newDailyLimit),
      monthly_total_limit: parseStringToNumber(data.newMonthlyLimit),
      daily_limit_enabled: !!data.newDailyLimitEnabled,
      monthly_limit_enabled: !!data.newMonthlyLimitEnabled,
      description: data.newDescription,
      min_income: +data.newMinIncome,
      max_income: +data.newMaxIncome,
      instant_active_orders: parseStringToNumber(data.newInstantOrders),
    };

    await updateCard({ cardId: Number(currentId), body })
      .unwrap()
      .then(() => {
        setCurrentId(null);
        reset();
      })
      .catch((e) => {
        if (e.data && e.data.non_field_errors) {
          e.data.non_field_errors.forEach((err: string) => pushNotify(err, 'Ошибка'));
        }
      });
  };
  return (
    <FormProvider {...formMethods}>
      <form onSubmit={handleSubmit(handleEdit)}>
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '12px',
            alignItems: 'end',
            marginBottom: '16px',
          }}
        >
          <div style={{ minWidth: '240px', flex: '1 1 240px' }}>
            <label style={{ display: 'block', fontSize: '14px', marginBottom: '6px' }}>
              Поиск по названию
            </label>
            <input
              value={search}
              onChange={(event) => {
                setSearch(event.target.value);
                setPage(1);
              }}
              placeholder='Введите тег реквизита'
              style={{
                width: '100%',
                height: '36px',
                padding: '0 12px',
                border: '1px solid #dbe0f2',
                borderRadius: '4px',
              }}
            />
          </div>
          <div>
            <label style={{ display: 'block', fontSize: '14px', marginBottom: '6px' }}>
              На странице
            </label>
            <select
              value={pageSize}
              onChange={(event) => {
                setPageSize(Number(event.target.value));
                setPage(1);
              }}
              style={{
                height: '36px',
                minWidth: '96px',
                padding: '0 12px',
                border: '1px solid #dbe0f2',
                borderRadius: '4px',
                background: '#fff',
              }}
            >
              {[10, 25, 50, 100].map((size) => (
                <option key={size} value={size}>
                  {size}
                </option>
              ))}
            </select>
          </div>
        </div>
        {version.isMobile ? (
          <CardsBlocks
            currentId={currentId}
            setCurrentId={setCurrentId}
            page={page}
            setPage={setPage}
            pageSize={pageSize}
            search={search}
            currentPageIds={currentPageIds}
            setCurrentPageIds={setCurrentPageIds}
          />
        ) : (
          <CardsTable
            currentId={currentId}
            setCurrentId={setCurrentId}
            page={page}
            setPage={setPage}
            pageSize={pageSize}
            search={search}
            currentPageIds={currentPageIds}
            setCurrentPageIds={setCurrentPageIds}
          />
        )}
      </form>
    </FormProvider>
  );
};
